



























import { Component, Vue, Emit, Prop } from "vue-property-decorator";

import { Dialog, Popup } from "vant";
import axios from "axios";
import { Notify } from "vant";
/* eslint-disable @typescript-eslint/class-name-casing */
/* eslint-disable @typescript-eslint/camelcase */

@Component({
  components: {},
})
export default class EditCategory extends Vue {
  show = false;
  Spiner = true;

  @Prop() type!: any;
  @Prop() index!: any;
  @Prop() word!: any;
  @Prop() words!: any;
  @Prop() wordId!: any;
  @Prop() category!: any;
  @Prop() Categories!: any;
  @Prop() CategoryName!: any;
  CategoryId: any = "";
  categoriesLength: number = 0;
  copyCategory = null;
  errors: any = [];
  dayOfTheWords: any;
  showLevel = true;

  wordlevel: any = null;
  @Emit("DeleteWordFromDictionary")
  DeleteWordFromDictionary() {
    return this.wordId;
  }
  @Emit("UpdateWords")
  UpdateWords() {
    return this.words;
  }

  async mounted() {
    const CatId = { request_payload: 10 };
    // get all category list
    const response = await axios.post(
      "https://api.englishjanala.com:8443/v1/englishjanala/core/CoreService/GetMonthlyWordsOfTheDay",
      CatId
    );
    // const data = response.data.levels;
    // this.wordLevels = data;
    // console.log(data);
    this.dayOfTheWords = response.data.monthlyWordsOfTheDay.dailyWordsOfTheDay;
    this.Spiner = false;
  }

  UpdateDayWord(day: any, words: any) {
    const data = {
      words_of_the_day: {
        day: day,
        words: words,
      },
    };

    const response = axios
      .post(
        "https://api.englishjanala.com:8443/v1/englishjanala/core/CoreService/PutWordsOfTheDay",
        data
      )
      .then()
      .catch((error) => {
        Notify({ type: "danger", message: "Word is not added in days" });
      });
    Notify({ type: "success", message: "Word is added in days" });
  }
  MoveOrCopy(day: any) {
    Dialog.confirm({
      title: "Copy",
      message: "Are you sure? <br/>Copy to day " + (day + 1),
      cancelButtonText: "No",
      confirmButtonText: "Yes",
    })
      .then(() => {
        this.dayOfTheWords[day].words.push({
          en: this.word.en,
          bn: this.word.bn,
          translationType: "EN_2_BN",

          description: this.word.description,
          partsOfSpeech: this.word.partsOfSpeech,
          presentForm: this.word.presentForm,
          pastForm: this.word.pastForm,
          pastParticipleForm: this.word.pastParticipleForm,
          synonyms: this.word.synonyms,
          antonyms: this.word.antonyms,
          examples: this.word.examples,
          imageUrl: this.word.imageUrl,
          isBookmarked: false,
          wordCategoryId: "",
          isUserGenerated: false,
          agreedToContribute: false,
          bookmarkCategoryName: "",
          isExpandable: true,
          frequency: 0,
          weight: 0,
        });

        Notify({ type: "success", message: "Word Added" });
        this.UpdateDayWord(day, this.dayOfTheWords[day].words);
        this.show = false;
      })
      .catch(() => {
        // on cancel
      });
  }
  DeleteCategory(id: any, index: any) {
    Dialog.confirm({
      title: "Copy",
      message: "Are you sure?",
      cancelButtonText: "No",
      confirmButtonText: "Yes",
    })
      .then(() => {
        const PassData = { category_id: id };
        const response = axios
          .post(
            "https://api.englishjanala.com:8443/v1/englishjanala/word/WordService/DeleteWordCategory",
            PassData
          )
          .then()
          .catch((error) => {
            Notify({ type: "danger", message: "Caategory is not deleted" });
          });
        this.$delete(this.Categories, index);
        Notify({ type: "success", message: "Caategory deleted" });
      })
      .catch(() => {
        // on cancel
      });
  }

  UpdateWordList(index: any) {
    this.show = false;
    const data = { category_id: this.CategoryId, level: this.wordlevel[index] };

    const response = axios
      .post(
        "https://api.englishjanala.com:8443/v1/englishjanala/word/WordService/UpdateWordLevel",
        data
      )
      .then()
      .catch((error) => {
        Notify({ type: "danger", message: "Word Level is not Updated" });
      });
    Notify({ type: "success", message: "Word Level Updated" });
    if (this.type == "move" && this.$route.name == "main.dictionary") {
      this.DeleteWordFromDictionary();
    } else if (this.type == "move" && this.$route.name == "main.single_level") {
      this.$delete(this.words, this.index);
      this.UpdateWords();
    }
  }

  showPopup() {
    this.show = true;
  }
  //   mounted() {
  //     const obj = this.category;
  //     this.copyCategory = Object.assign({}, obj);
  //     // console.log("copy ", copy); // { a: 1 }
  //   }
}
